import styled from 'styled-components';
import { breakpoints, spacing } from '@naf/theme';

export const AddressInfo = styled.div`
  margin-top: ${spacing.space32};
  margin-left: ${spacing.space48};

  p {
    font-size: 1rem;
  }

  @media (max-width: ${breakpoints.m}) {
    margin-left: 0;
    width: 100%;
  }
`;
